import { render, staticRenderFns } from "./productPrice.vue?vue&type=template&id=101ad5a4&scoped=true&"
import script from "./productPrice.vue?vue&type=script&lang=js&"
export * from "./productPrice.vue?vue&type=script&lang=js&"
import style0 from "./productPrice.vue?vue&type=style&index=0&id=101ad5a4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101ad5a4",
  null
  
)

export default component.exports